export const PROGRESS_BAR_TYPES = {
  BADGE_CARD_VERSION: "BADGE_CARD_VERSION",
  DETAILS_CARD_VERSION: "DETAILS_CARD_VERSION",
  HEADER_VERSION: "HEADER_VERSION",
  TOPIC_CARD_VERSION: "TOPIC_CARD_VERSION",
  REWARDS_CARD_VERSION: "REWARDS_CARD_VERSION",
};
